<template>
    <div class="main mt15">
        <div class="banner" @click="toBuy">
            <img src="../../../images/tbTsb.jpg" alt="" ref="info">
        </div>
        <div class="tabs" ref="tabs">
            <div class="tabs-container" :class="{fixed:fixed}">
                <Tabs :value="tabName" @on-click="tabChange">
                    <TabPane label="产品特色" name="info"></TabPane>
                    <TabPane label="保障方案" name="case"></TabPane>
                    <TabPane label="常见问题" name="question"></TabPane>
                    <TabPane label="理赔流程" name="claim"></TabPane>
                </Tabs>
                <div class="tabs-container-form" v-show="fixed">
                    <Button type="primary" @click="toBuy">立即购买</Button>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">产品特色</div>
            <div class="detail-main">
                <div style="color: red;">咨询电话：187 6642 6120</div>
                <div class="detail-main-text" ref="case">
                    投标保证保险，是保险人对投标人投标行为的一种担保，用来保证中标人和业主签约后，会履行投标文件中的承诺，在投保了投标保证保险后，若是中标人因故撤销投标、放弃中标或不履行投标文件里的承诺，又或者违反招投标的约定，保险公司就会向招标人所遭受的损失进行赔偿。保险公司赔偿后，还可以向投标人进行追偿。<br />
                    在保险期间内，投保人在向被保险人招标项目进行投标的过程中违反《招标文件》规定要求，给被保险人造成直接损失的，保险人依据本保险合同的约定，以保险单所载的保险金额为限，对被保险人的上述损失承担赔偿责任。
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">保障方案</div>
            <div class="detail-main">
                <div class="center">
                    <table class="productDetail-table">
                        <thead>
                            <tr>
                                <th>项目</th>
                                <th>内容</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hoverTr">
                                <td>投保人</td>
                                <td>投标人</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>被保险人</td>
                                <td>招标人</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>项目名称</td>
                                <td>按照招标文件中的为准</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>产品优势</td>
                                <td>可有效替代投标保证金，极大释放企业资金</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>保额</td>
                                <td>投标保证金额</td>
                            </tr>
                            <tr class="hoverTr" ref="question">
                                <td>保险期限</td>
                                <td>最长不超过180天</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>保费</td>
                                <td>保险金额*保险费率（保险费率低至千1.5）</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">常见问题</div>
            <div class="detail-main">
                <div class="detail-main-text">
                    <p><b>1、企业为什么要买投标保证保险？</b></p>
                    <p>
                        答：企业参与投标需要缴纳投标保证金，而投标保证保险是国家政策明文支持的创新投标保证金代替形式。
                    </p>
                    <p ref="claim"><b>2、为何选择我们投保？</b></p>
                    <p>答：成本优势：费率可低至千1.5，盘活企业投标保证金99.85%<br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;办理优势：在线投保，实时出单；不占授信，无需反担保。<br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;服务优势：全流程管家服务，24小时全天候线上出单。
                    </p>
                    <p><b>3、如何投保？</b></p>
                    <p >答：点击立即购买输入基础信息提交付款后，保单会发送到您预留的邮箱中，方便快捷。</p>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">理赔流程</div>
            <Steps class="mt30 step-con">
                <Step 
                    title="拨打报案电话" 
                    status="process"
                    content="请立即拨打报案电话18766426120进行报案，详细说明出险情况。被保险人应在48小时内及时报案。"
                ></Step>
                <Step 
                    title="提交索赔材料" 
                    status="process"
                    content="报案后我们会告知您所需的材料，请按照要求待治疗结束后提供资料。"
                ></Step>
                <Step 
                    title="领取赔款" 
                    status="process"
                    content="资料收到后，保险公司核定损失，确定赔偿金额，按照约定赔付方式支付赔款。"
                ></Step>
            </Steps>
        </div>
        <TrackNotice />
    </div>
</template>
<script>
    import TrackNotice from '@/components/common/TrackNotice.vue';
    import track from "@/mixin/track";
    export default {
        components:{ TrackNotice },
        mixins:[ track ],
        data () {
            return {
                rules: {
                    code: [{ required: true, message: '请输入88码', trigger: 'blur' }]
                },
                tabName: 'info',
                fixed: false,
                renewId: this.$route.query.renewId || '' //续保，上一保单id
            }
        },
        mounted() {
            this.track_is_new = true;
            this.$nextTick(()=>{
                window.addEventListener("scroll", this.handleScroll);
                this.trackInit(); 
            })
        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.handleScroll)
        },
        methods: {
            // 立即购买
            toBuy () {
                this.stopRecord({
				    is_new: true
                }).then(()=>{
                    let url = '/haierProduct.html#/customized-employer-liability/FillinCompany';
                    if (this.renewId) url += `/${this.renewId}?renew=1&productCode=JIANGONG_DEPOSIT`
                    else url += `?productCode=JIANGONG_DEPOSIT`
                    location.href = url
                })
            },
            // tab切换
            tabChange (val) {
                this.$refs[val].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                    block: "start"
                })
            },
            // 定位到伤残费率表位置
            toSC () {
                this.$refs['SC'].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                })
            },
            // 监听滚动
            handleScroll () {
                //获取滚动时的高度
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > this.$refs.tabs.offsetTop) {
                    this.fixed = true;
                } else {
                    this.fixed = false;
                }
            }
        }
    }
</script>
<style scoped lang="less">
    .main {
        margin-bottom: 30px;
    }

    .pb50 {
        padding-bottom: 50px;
    }

    .pt40 {
        padding-top: 40px;
    }

    .banner-container {
        position: absolute;
        font-size: 14px;
        text-align: center;
        width: 510px;
        top: 80px;
        left: 0;
        right: 0;
        color: #fff;

        .notes {
            margin-top: 10px;
        }

        &-title {
            font-size: 32px;
            color: #333;
        }

        &-case {
            font-size: 24px;
            line-height: 2;
            color: #318af0;
        }

        &-sub {
            font-size: 14px;
            color: #555;
            margin-top: 30px;

            span {
                margin-right: 5px;
            }
        }

        &-desc {
            font-size: 18px;
        }

        &-input {
            width: 300px;
            margin: 20px auto 0;
        }

        &-btn {
            margin-top: 30px;

            a {
                width: 240px;
            }
        }
    }

    .detail-title {
        font-size: 30px;
    }

    .detail-main {
        .center {
            font-size: 0;
        }

        &-title,
        &-text {
            // padding-left: 20px;
        }

        &-title {
            font-size: 18px;
        }

        &-text {
            line-height: 2;
        }
    }

    .tabs {
        display: block;
        height: 46px;

        &-container {
            padding: 10px 10px 0;
            background: #fff;
            height: 46px;
            overflow: hidden;
            position: relative;

            &-form {
                position: absolute;
                right: 10px;
                bottom: 5px;

                button {
                    display: inline-block;
                }
            }
        }

        .fixed {
            position: fixed;
            top: 100px;
            left: 0;
            right: 0;
            margin: auto;
            width: 1200px;
        }
    }

    .productDetail-table.sm {
        font-size: 13px;

        .fs16 {
            font-size: 16px;
        }

        td {
            padding: 8px;
        }
    }

    .hoverTr:hover {
        color: #fff;

        td {
            background: #77adf5;
        }

        .hoverDisabled {
            background: #fafafa;
            color: #333;
        }
    }

    .importantText {
        color: #77adf5;
    }

    .tit {
        font-size: 18px;
        margin: 10px 0;
    }
    .step-contain{
        display: flex;
        justify-content: space-between;
        .step-item{
            width: 26%;
        }

    }
    .step-con {
        margin-bottom: 20px;
    }
    .step-con .ivu-steps-item:last-child{
        flex: 1 !important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/productList/bidDetail.vue